import { Money } from '@ap/interface-bspc-core';
import { PersonalLoan } from '@ap/ap-interface-apix-hypotheken-berekening';

export class PersonalLoanBuilder {
    private monthlyAmount: Money;
    private originalAmount: Money;

    withOriginalAmount(originalAmount: Money): this {
        this.originalAmount = originalAmount;
        return this;
    }

    withMonthlyAmount(monthlyAmount: Money): this {
        this.monthlyAmount = monthlyAmount;
        return this;
    }

    build(): PersonalLoan {
        return {
            monthly_amount: this.monthlyAmount,
            original_amount: this.originalAmount
        } as PersonalLoan;
    }
}
